// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface ManufacturerAvailabiltiesApiParameter extends ApiParameter {
    productIds: string[];
}

interface RockwellInventory {
    availableQuantity: number;
    availableQuantityUom: string;
    catalogId: string;
}

interface HoffmanInventory {
    availability: number;
    manufacturerLocation: string;
}

interface PanduitInventory {
    itemName: string;
    partLeadTime: number;
    partStockLevel: number;
    partStockLevelUom: string;
    pkgQty: number;
}
interface PanduitInventory {
    company: number;
    region: string;
    inventory: PanduitInventory[];
}

export interface RockwellManufacturerAvailabilty {
    city: string;
    inventories: RockwellInventory[];
}

export interface HoffmanManufacturerAvailabilty {
    bestShipDate: string;
    manufacturerLocation: HoffmanInventory[];
}
export interface PanduitManufacturerAvailabilty {
    panduitInventory: PanduitInventory;
}

export interface RockwellManufacturerAvailabiltyModel extends BaseModel {
    rockwellProductInventoryList: RockwellManufacturerAvailabilty[];
}

const rockwellUrl = `api/mcmc/product/getRockwellInventory`;
const hoffmanUrl = `api/mcmc/product/getHoffmanInventory`;
const panduitUrl = `api/mcmc/product/getPanduitInventory`;

export async function getRockwellInventoryManufacturerAvailabilties(parameter: ManufacturerAvailabiltiesApiParameter) {
    const availabilities = await get<RockwellManufacturerAvailabiltyModel>(`${rockwellUrl}`, parameter);
    return availabilities;
}

export async function getHoffmanInventoryManufacturerAvailabilties(parameter: ManufacturerAvailabiltiesApiParameter) {
    const availabilities = await get<HoffmanManufacturerAvailabilty>(`${hoffmanUrl}`, parameter);
    return availabilities;
}

export async function getPanduitInventoryManufacturerAvailabilties(parameter: ManufacturerAvailabiltiesApiParameter) {
    const availabilities = await get<PanduitManufacturerAvailabilty>(`${panduitUrl}`, parameter);
    return availabilities;
}
